'use client';

import { useState, useEffect } from 'react';

var useCollapseElement = function (_a) {
    var element = _a.element, // container element to collapse
    _b = _a.transition, // container element to collapse
    transition = _b === void 0 ? 500 : _b, _c = _a.defaultCollapse, defaultCollapse = _c === void 0 ? false : _c, // collapse status at beginning
    _d = _a.collapseHeight, // collapse status at beginning
    collapseHeight = _d === void 0 ? 0 : _d, // minimum collapse height
    _e = _a.dependencies // calculate height again when data change
    , // minimum collapse height
    dependencies = _e === void 0 ? [] : _e // calculate height again when data change
    ;
    var _f = useState(defaultCollapse), isCollapse = _f[0], setCollapse = _f[1];
    var _g = useState(false), isAlreadyFitHeight = _g[0], setAlreadyFitHeight = _g[1];
    var onCollapseClick = function () {
        if (!element.current)
            return;
        if (!isCollapse) {
            element.current.style.height = "".concat(collapseHeight, "px");
            setCollapse(true);
        }
        else {
            element.current.style.height = "".concat(element.current.scrollHeight, "px");
            setCollapse(false);
        }
    };
    useEffect(function () {
        var _a;
        if (element.current) {
            element.current.style.transition = "height ".concat(transition, "ms");
            element.current.style.overflow = 'hidden';
            element.current.style.height = 'auto';
            // example: if element height = 190 but initial collapse height = 200
            // so element height should be itself, not 200
            if (collapseHeight < Number((_a = element.current) === null || _a === void 0 ? void 0 : _a.scrollHeight)) {
                element.current.style.height = isCollapse ? "".concat(collapseHeight, "px") : "".concat(element.current.scrollHeight, "px");
                setAlreadyFitHeight(false);
            }
            else {
                setAlreadyFitHeight(true);
            }
        }
    }, dependencies);
    return {
        isAlreadyFitHeight: isAlreadyFitHeight,
        isCollapse: isCollapse,
        onCollapseClick: onCollapseClick
    };
};

export { useCollapseElement as default };
//# sourceMappingURL=useCollapseElement.js.map
